import { IProperties } from 'core-components/sitebuilder/propertygenerator'

import { IColumnExtended } from '../../models/ITableExtendedProps'

import { calcColumnRenderFunction } from './calcColumnRenderFunction'
import { loadTemplateData } from './loadTemplateData'

export const prepareProps = async (properties: IProperties[]) => {
  const tableProps: any = {}
  const filteredProperties = properties.filter((p) => p.value !== undefined && p.value !== '')
  for (const p of filteredProperties) {
    let needLoad = p.needLoad
    if (p.type === 'custom') {
      needLoad = isNeedLoad(p.value)
    }

    if (needLoad && p.value) {
      const templateFunction = await loadTemplateData(p.value)
      if (templateFunction) {
        tableProps[p.name] = templateFunction
      }
    } else {
      if (p.name === 'columns') {
        await prepareColumnProperty(p.name, p.value, tableProps)
      } else {
        tableProps[p.name] = p.value
      }
    }
  }
  return tableProps
}

const prepareColumnProperty = async (propertyName: string, value: unknown, tableProps: object) => {
  const mapData = value ? [...(value as IColumnExtended[])] : []
  tableProps[propertyName] = []
  for (const column of mapData) {
    const newColumn = { ...column }
    const renderFunction = await calcColumnRenderFunction(newColumn)
    if (renderFunction) {
      newColumn.renderFunction = renderFunction
    }
    if (column.customFilter) {
      newColumn.customFilter = await loadTemplateData(column.customFilter)
    }
    tableProps[propertyName].push(newColumn)
  }
}

const isNeedLoad = (value: string | unknown) => {
  if (typeof value === 'string') {
    const [path, name] = `${value}`.split(':')
    if (path && name) {
      return true
    }
  }
  return false
}
